import React from 'react'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { reduxForm } from 'redux-form'
import { listar_obj } from '../../actions'
import { getCustonComponenteField, getConfigComponente } from '../../../function';

const mapStateToProps = (state, props) => {

    const { customFormUid, funcFiltroLista } = props
    const { DinamicCustomFormsReducer } = state

    const controler = DinamicCustomFormsReducer.rLista;
    let listaForms = controler.lista;
    let customForm = null;
    listaForms.forEach(f => {
        if (f.uid === customFormUid) {
            customForm = f;
        }
    });




    let loading = true;
    let lista = null;
    let chaveReducer = customFormUid;

    if (customForm.chaveSalvar) {
        chaveReducer = customForm.chaveSalvar
    }
    if (DinamicCustomFormsReducer.rListaObj[chaveReducer]) {
        loading = DinamicCustomFormsReducer.rListaObj[chaveReducer].loading;
        lista = DinamicCustomFormsReducer.rListaObj[chaveReducer].lista;
    }

    let listaFinal = [];
    if (lista) {
        listaFinal = lista.slice()
    }

    if (funcFiltroLista) {
        listaFinal = funcFiltroLista(listaFinal)

    }
    let colunas = []
    if (props.colunas) {
        criaColunas2(props.colunas, props.filtros, colunas, props.custonFormReferente)
    } else {
        criaColunas(customForm.componenteRoot.componentes, colunas)
    }
    return {
        form: 'CustonFormConsultaForm' + customForm.nomeForm,
        customForm,
        loading, listaPesquisa: listaFinal, titulo: customForm.nomeForm, colunas, global
    };
};


export default compose(
    connect(mapStateToProps, { listar: listar_obj }),
    reduxForm(),


);

function criaColunas(components, colunas) {


    components.forEach(comp => {
        let c = null
        if (comp.colunaPesquisa) {
            c = {
                id: comp.field, label: comp.label, getValue: item => {
                    let r = item[comp.field]
                    if (typeof r == typeof true) {
                        if (r) {

                            return "Sim"
                        } else {

                            return "Não"
                        }
                    }


                    return r
                }
            }

        }
        if (comp.filtroPesquisa) {
            c = { id: comp.field, label: comp.label, getValue: item => item[comp.field], filtro: true }
        }

        if (c) {
            colunas.push(c)
        }

        if (comp.componentes) {
            criaColunas(comp.componentes, colunas)
        }
    });
    if (!colunas.length) {
        colunas.push({ id: "UID", label: "UID", getValue: item => item.uid })
    }
    return colunas;

}


function criaColunas2(colunas, filtros, array, custonFormReferente) {

    colunas.forEach(field => {

        let label = field;
        let renderFiltro = null;
        let confComp = getConfigComponente(custonFormReferente, field)
        let custonComponente = getCustonComponenteField(custonFormReferente, field);
        if (custonComponente) {

            label = confComp.label;
            if (custonComponente.renderFiltro) {
                renderFiltro = custonComponente.renderFiltro
            }
        }

        let filtro = true

        if (filtros && filtros.length) {
            filtro = filtros.includes(field)
        }
        let c = {
            id: field, label: label,
            filtro: filtro,
            renderFiltro: renderFiltro,
            confComp,
            getValue: item => {
                let r = item[field]
                if (typeof r == typeof true) {
                    if (r) {
                        return "Sim"
                    } else {

                        return "Não"
                    }
                }


                return r
            }
        }
        array.push(c)

    })

    if (!array.length) {
        array.push({ id: "UID", label: "UID", getValue: item => item.uid })
    }
    return array;

}



// WEBPACK FOOTER //
// ./src/routes/sistema/DinamicForms/components/DinamicCrudCustomConsulta/DinamicCrudCustomConsulta.enhancer.js